import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {OperationTaskImageModel} from '@app/shared/models/operation-task-image.model';
import {AuthenticationService} from "@app/authentication/services/authentication.service";
import {TaskInstructionType} from "@models/enums/task-instruction-type.enum";

@Component({
    selector: 'app-ticket-task-details',
    templateUrl: './ticket-task-details.component.html',
    styleUrls: ['./ticket-task-details.component.scss']
})
export class TicketTaskDetailsComponent implements OnInit, OnChanges {
    @Input() task: any;
    @Input() toolCount = 1;
    @Input() infoMessage: string;

    @Output() downloadDocuments = new EventEmitter<any>();
    @Output() previewDocuments = new EventEmitter<any>();
    @Output() onUpdateTicketTask = new EventEmitter<any>()

    carouselVisible = true;
    photos: OperationTaskImageModel[] = [];

    constructor(private authService: AuthenticationService) {
    }

    ngOnInit() {
        this.handlePhotosChanged(this.task.operationTask.photos);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.photos) {
            this.handlePhotosChanged(changes.photos.currentValue);
        }
    }

    handlePhotosChanged(currentValue) {
        this.photos = currentValue;
    }

    toggleCarouselVisible(event: any) {
        event.preventDefault();
        event.stopPropagation();

        this.carouselVisible = !this.carouselVisible;
    }

    formatDescription(description: string) {
        return description.replace(/\n/g, "<br>");
    }

    onDownloadDocuments(event: any, spare = false) {
        event.preventDefault();
        event.stopPropagation();

        this.downloadDocuments.emit(spare);
    }

    onPreviewDocuments(event: any, spare = false) {
        event.preventDefault();
        event.stopPropagation();

        this.previewDocuments.emit(spare);
    }

    updateTicketTask() {
        this.onUpdateTicketTask.emit({
            'ticketTaskId': this.task.id,
            'requiresObservation': this.task.requiresObservation,
            'requiresSpare': this.task.requiresSpare
        })
    }

    isRequiresObservationDisabled(task: any) {
        if (task.status !== 0 || !this.authService.hasPermission('PROCESS_TICKETS')) {
            return true;
        }

        return task.operationTask.requiresObservation;
    }

    isRequiresSpareDisabled(task: any) {
        if (task.status !== 0 || !this.authService.hasPermission('PROCESS_TICKETS')) {
            return true;
        }
        return task.operationTask.hasSpare && task.operationTask.mandatorySpare;
    }

    computeRecurrences(task: any) {
        return task.recurrences.map(item => item.name).join(', ');
    }

    hasInstructionDocument(task: any, spare: boolean) {
        return task.operationTask.files.length !== 0 &&
            task.operationTask.files.find(
                item => item.type === (spare ? TaskInstructionType.SPARE : TaskInstructionType.WORK));
    }
}
